import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { updateHeader } from './slices/header-slice';
import { updatePagesData, setPagesLoading, setPagesError } from './slices/pages-slice';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LoadingProvider } from './contexts/LoadingContext';
import SplashWrapper from './components/splash-wrapper';
import { getPages } from './api';

import './App.scss'

//Components
import Header from './components/header'
import Footer from './components/footer'
import Showcase from './components/showcase';
import CartPreview from './components/cart-preview';
import Arrow from './components/arrow';

//Pages
import Product from './pages/product';
import OurStory from './pages/story/our-story';
import JeffreyGreene from './pages/jeffrey-greene';
import Custom from './pages/custom/custom';
import CheckOut from './pages/checkout';
import TableBuilder from './pages/table-builder';
import Cart from './pages/cart';
import Store from './pages/store';
import Home from './pages/home/home';
import Portfolio from './pages/portfolio/portfolio';
import FAQs from './pages/faqs';
import Contact from './pages/contact/contact';
import AdditionalServices from './pages/additional-services';
import Slabs from './pages/slabs';
import Bases from './pages/bases';
import WishList from './pages/wishlist';
import SubscribeModal from './components/subscribe-modal';
import Media from './pages/media';
import MediaPost from './pages/media-post';
import News from './pages/news';
import Divergence from './pages/divergence';
import ContactSubmitted from './pages/contact-submitted/contact-submitted';
import Newsletter from './pages/newsletter';
import LookBook from './pages/look-book';
import CustomPage from './pages/custom-page';

function App() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [showCaseItem, setShowcaseItem] = useState(null);
  const [isFirstVisit, setIsFirstVisit] = useState(false);
  const hasFetchedPages = useRef(false);

  // Fetch custom pages on app initialization
  useEffect(() => {
    if (!hasFetchedPages.current) {
      hasFetchedPages.current = true;
      dispatch(setPagesLoading());

      getPages()
        .then((response) => {
          dispatch(updatePagesData(response.data));
        })
        .catch((error) => {
          console.error('Error fetching pages:', error);
          dispatch(setPagesError(error.message || 'Failed to fetch pages'));
        });
    }
  }, [dispatch]);

  useEffect(() => {
    const visited = localStorage.getItem('paramount_wood_co_visited');
    if (!visited) {
      const timeOut = setTimeout(() => {
        setIsFirstVisit(true);
        localStorage.setItem('paramount_wood_co_visited', 'true');
        clearTimeout(timeOut)
      }, 30000)
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowcaseItem(null)
  }, [pathname]);

  useEffect(() => {
    if (showCaseItem) {
      dispatch(updateHeader('dark'))
      document.body.classList.add('modal');
      const showcaseEl = document.querySelector('.portfolio-showcase');
      showcaseEl.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      dispatch(updateHeader('light'))
      document.body.classList.remove('modal')
    }
  }, [showCaseItem, dispatch])

  const handleClosePopup = () => {
    setIsFirstVisit(false);
  };

  return (
    <HelmetProvider>
      <LoadingProvider minSpinnerDelay={0}>
        <SplashWrapper minSplashTime={2600}>
           <>
             <Header />
             <Routes>
               <Route path="/" element={<Home />} />
               <Route path="/portfolio" element={<Portfolio setShowcaseItem={setShowcaseItem} />} />
               <Route path="/shop" element={<Store />} />
               <Route path="/slabs" element={<Slabs type={"slabs"} />} />
               <Route path="/bases" element={<Bases type={"bases"} />} />
               <Route path="/our-story" element={<OurStory />} />
               <Route path='/jeffrey-greene' element={<JeffreyGreene />} />
               <Route path="/products/:id/:variantId?" element={<Product type="products" />} />
               <Route path="/slabs/:id/:variantId?" element={<Product type="slabs" />} />
               <Route path="/bases/:id/:variantId?" element={<Product type="bases" />} />
               <Route path="/divergence" element={<Divergence />} />
               <Route path="/custom-design" element={<Custom />} />
               <Route path="/check-out" element={<CheckOut />} />
               <Route path="/table-builder" element={<TableBuilder />} />
               <Route path="/cart" element={<Cart />} />
               <Route path="/faqs" element={<FAQs />} />
               <Route path="/contact" element={<Contact />} />
               <Route path="/additional-services" element={<AdditionalServices />} />
               <Route path="/wishlist" element={<WishList />} />
               <Route path="/media" element={<Media />} />
               <Route path="/media/:id" element={<MediaPost />} />
               <Route path="/news" element={<News />} />
               <Route path="/newsletter/:campaignId" element={<Newsletter />} />
               <Route path="/look-book" element={<LookBook />} />
               <Route path="/contact-submitted" element={<ContactSubmitted />} />
               <Route path="/page/:id" element={<CustomPage />} />
             </Routes>

            <Showcase showCaseItem={showCaseItem} setShowcaseItem={setShowcaseItem} />

            <CartPreview />
            <Footer />

            <Arrow />

            {isFirstVisit && <SubscribeModal onClose={handleClosePopup} />}
          </>
        </SplashWrapper>
      </LoadingProvider>
    </HelmetProvider>
  );
}

export default App;
